"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var Wrapper =
/*#__PURE__*/
(0, _styled.default)("label", {
  target: "emawvna0"
})(function (_ref) {
  var theme = _ref.theme;
  return {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    margin: '8px 0',
    borderBottom: theme.mainBorder,
    padding: '0 8px 8px 8px',
    '&:last-child': {
      borderBottom: '0 none',
      paddingBottom: 0
    }
  };
});
var Label =
/*#__PURE__*/
(0, _styled.default)("span", {
  target: "emawvna1"
})({
  minWidth: 100,
  minHeight: 32,
  marginRight: 16,
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  lineHeight: '16px'
});

var Field = function Field(_ref2) {
  var label = _ref2.label,
      children = _ref2.children;
  return _react.default.createElement(Wrapper, null, label ? _react.default.createElement(Label, null, _react.default.createElement("span", null, label)) : null, children);
};

Field.propTypes = {
  label: _propTypes.default.node,
  children: _propTypes.default.node.isRequired
};
Field.defaultProps = {
  label: undefined
};
var _default = Field;
exports.default = _default;